/**
 * Reusable masks to pass into TextField
 *
 * See: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#mask
 */

import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { conformToMask as ctm, conformToMaskResult } from 'react-text-mask';

import { prop, pipe } from 'ramda';

export const phoneMask = [
  '(',
  /[2-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const dateMask = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const moneyMask = createNumberMask({
  prefix: '$',
  integerLimit: 7,
  decimalLimit: 0,
});

export const decimalMoneyMask = createNumberMask({
  prefix: '$',
  integerLimit: 7,
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  allowNegative: false,
  allowLeadingZeroes: false,
});

export const ssnMask = (isLastFour: boolean) =>
  isLastFour
    ? [/\d/, /\d/, /\d/, /\d/]
    : [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

export const intendedPurchaseAmountMask = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const stateMask = [/[A-Za-z]/, /[A-Za-z]/];

export const prescreenIdMask = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const storeNumberMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowLeadingZeroes: true,
});

export const conformToMask = pipe<
  string,
  (string | RegExp)[],
  conformToMaskResult,
  string
>(
  (val, mask) => ctm(val, mask, {}),
  prop('conformedValue'),
);

export const dobPipe = createAutoCorrectedDatePipe('mm/dd/yyyy');
